import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { TuiAppearance, TuiButton, TuiLoader } from '@taiga-ui/core';
import { FaqQuestionUi } from '../../../core/faq/faq.model';
import { TuiPagination } from '@taiga-ui/kit';
import { TuiExpand } from '@taiga-ui/experimental';
import { SafePipe } from '../../../ui/pipes/safe.pipe';
import { TuiBlockStatus } from '@taiga-ui/layout';
import { toSignal } from '@angular/core/rxjs-interop';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'app-faq-questions',
  imports: [
    TuiLoader,
    TuiButton,
    TuiExpand,
    SafePipe,
    TuiBlockStatus,
    TuiPagination,
    TuiAppearance
  ],
  templateUrl: './faq-questions.html',
  styleUrl: './faq-questions.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FaqQuestions {
  readonly isLoading = input<boolean>(false);
  readonly questions = input<FaqQuestionUi[] | null>(null);
  readonly pagesCount = input.required<number>();
  readonly currentPage = input.required<number>();

  readonly changePage = output<number>();

  readonly #breakpoint = inject(BreakpointObserver);

  protected readonly isMobile = toSignal(this.#breakpoint.observe('width <= 480px'));

  protected toggleFaqQuestion(item: FaqQuestionUi) {
    item.expanded = !item.expanded;
  }
}
